import * as React from "react";

export const SvgJOSHome = (props) => (
	<svg width={37} height={37} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x={0.5} y={0.5} width={36} height={36} rx={8} fill="#FFF8EA" />
		<path
			d="m27.849 15.411-9-6.4a.6.6 0 0 0-.696 0l-9 6.4a.599.599 0 0 0-.253.489v2.8a.601.601 0 0 0 .948.49l.652-.465V27.3a.8.8 0 0 0 .8.8h1.6v-9.6h11.2v9.6h1.6a.8.8 0 0 0 .8-.8v-8.575l.653.464a.602.602 0 0 0 .948-.49v-2.8a.6.6 0 0 0-.252-.488Z"
			fill="#FFB11A"
		/>
		<path d="M14.1 26.1h8.8v2h-8.8v-2ZM14.1 22.9h8.8v2h-8.8v-2ZM14.1 19.7h8.8v2h-8.8v-2Z" fill="#FFB11A" />
	</svg>
);
